import React, { Component } from "react";
import PageTextColumn from './PageTextColumn';
import PageImageColumn from './PageImageColumn';
import WithConsumer from '../../context/WithConsumer';

export default class PageColumns extends Component {
	
	render () {
		
		let block = this.props.block;
				
		if (block) {
									
		    return (
			    
			    <div id={block.id} className={'c-page__block c-page__block--load-effect'}>
			    
			    	<div className="l-content c-columns">
			    		
			    		<div className="l-grid">
			    		
			    			{block.heading &&
			    		
				    			<div className="l-grid__col">
				    			
				    				<h2 className="c-heading" dangerouslySetInnerHTML={{__html: block.heading}}></h2>
				    											
								</div>
							
							}
							
							{block.columns.map((column,i) =>
								{
									
									let colClass = 'c-columns__column l-grid__col l-grid__col--m-6-12 l-grid__col--l-4-12 l-grid__col--l-push-4-12';
									if (i == 0 && column.srcset) {
										colClass = 'c-columns__column l-grid__col l-grid__col--m-6-12 l-grid__col--l-4-12';
									} else if (i != 0) {
										colClass = 'c-columns__column l-grid__col l-grid__col--m-6-12 l-grid__col--l-4-12';
									}
									return (
										<div className={colClass} key={i}>
											{column.src && column.heading &&
												<PageImageColumn	item={column}></PageImageColumn>
											}
											{!column.src &&
												<PageTextColumn	item={column}></PageTextColumn>
											}
										</div>
									)
								}
							)}
			    			
			    		</div>
			    		
			    	</div>
			    
			    </div>
			)
			
		} else {
			
			return null;
		
		}
	}
}
